import React from "react";
import AdminPage from "../AdminPage";
import useAdminList from "../useAdminList";
import BlogRequests from "../BlogRequests/BlogRequests";

const COPY = {
  title: "Blog Requests",
  subtitle: "You Can View Accept & Reject Blog Requests",
  searchPlaceholder: "Search Here",
};

const BlogRequestsAdmin = () => {
  const { items, loading, searchValue, setSearchValue } =
    useAdminList("getBlogRequests");

  return (
    <AdminPage
      title={COPY.title}
      subtitle={COPY.subtitle}
      loading={loading}
      search={{
        value: searchValue,
        onChange: setSearchValue,
        placeholder: COPY.searchPlaceholder,
      }}
    >
      <BlogRequests driverData={items} />
    </AdminPage>
  );
};

export default BlogRequestsAdmin;
